import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import MainHeader from './MainHeader';
import Navbar from './Navbar';


const NewHeader = () => {

    const [isSticky, setIsSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const offset = window.scrollY;

            if (offset > 200) {
                setIsSticky(true);
            } else {
                setIsSticky(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Cleanup function to remove event listener
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };

    }, []);


    const handleSkipToContent = (e) => {
        e.preventDefault();
        const section = document.getElementById('nutrition');

        if (section) {
            const yOffset = -220; // Adjust offset value here too
            const yPosition = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: yPosition, behavior: "smooth" });

        }
    };







    return (
        <header className="newHeader">
            <div className="newHeader--top">
                <div className="container space-container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="d-flex justify-content-end align-items-center mobile_header">
                                <div className="newHeader--top-links d-none">
                                    <NavLink to="/">Help</NavLink>
                                    <span className='dividerSec'>|</span>
                                    <NavLink to="/contact">Contact Us</NavLink>
                                    <span className='dividerSec'>|</span>
                                    <NavLink to="/">Sitemap</NavLink>
                                </div>
                                <div className="newHeader--top-links">
                                    <NavLink onClick={handleSkipToContent}>Skip to main content</NavLink>
                                    <span className='dividerSec'>|</span>
                                    <NavLink to="/contact">Contact Us</NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={`${isSticky ? 'sticky' : ''}`}>
                <MainHeader />
                <Navbar />
            </div>






            <div className="modal fade epustakalaya-app" id="epustakalaya" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <button type="button" className="modal-close icofont-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        <div className='container'>
                            <div className='row view-gallery'>
                                <div className='col-md-12 text-center '>
                                    <h4 className='qr-title'>Simply scan the QR code to download the app instantly!</h4>
                                    <img src="assets/images/elements/NBT-QR.png" className="qr-code" alt="QR-code" />
                                    <div className="col-md-12 text-center">
                                        <NavLink to="/home" className="light">
                                            <img src={`${process.env.PUBLIC_URL}/assets/images/epustak_light_mode.png`} className='epustak-logo' alt="logo" />
                                        </NavLink>
                                        <NavLink to="/home" className="dark">
                                        <img src={`${process.env.PUBLIC_URL}/assets/images/epustak_dark_mode.png`} className='epustak-logo' alt="logo" />
                                        </NavLink>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="modal fade modal_event" id="amritKaal" tabIndex="-1" aria-labelledby="amritKaalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">

                    <div className="modal-content" data-aos="flip-left" data-aos-easing="ease-out-cubic" data-aos-duration="1000">
                        <button type="button" className="modal-close icofont-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        <div className="product-view">
                            <a href="/event_info">
                                <img className="img-responsive w-100" src="assets/images/elements/amrit_kaal.png" alt="Amrit Kaal Event" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        </header>


    )
}

export default NewHeader;
